export default __webpack_public_path__ + "static/media/alliant-logo.7983cbe1.svg";